import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

import { mergeRemoteValues } from '../utils/mergeRemoteValues';

export interface LiveRecordMergeProps {
  readonly record?: Record<any, any>;
}

export const LiveRecordMerge = ({ record }: LiveRecordMergeProps) => {
  const { values, setValues } = useFormikContext<Record<any, any>>();
  const prevRef = useRef(record);

  // Deliberately keyed on `record` only: this must read the `values` of the commit the new
  // record arrived in, and re-running on `values` too would loop (a merge write changes `values`).
  useEffect(() => {
    if (!record) {
      return;
    }

    const { merged, changedPaths } = mergeRemoteValues(prevRef.current ?? record, record, values);

    prevRef.current = record;

    if (changedPaths.length) {
      setValues(merged);

      if (process.env.NODE_ENV === 'development') {
        // Field paths and a count only — values are applicant PII, some special-category.
        console.info('[live-form-updates] merged %d path(s): %s', changedPaths.length, changedPaths.join(', '));
      }
    }
  }, [record]);

  return null;
};
